import { render, staticRenderFns } from "./customer_information.vue?vue&type=template&id=66f48fbc&scoped=true&"
import script from "./customer_information.vue?vue&type=script&lang=js&"
export * from "./customer_information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f48fbc",
  null
  
)

export default component.exports